import Select, { SelectProps } from '@material-ui/core/Select';

export const SelectInput = (props: SelectProps) => {
  return <Select variant={props.variant || 'outlined'} fullWidth {...props} />;
};
